import { jsx as _jsx } from "react/jsx-runtime";
import styles from './IconButton.module.css';
import cx from '../../utils/classNames';
const IconButton = (props) => {
    return (_jsx("div", Object.assign({ className: cx(styles.iconButton, props.className), onClick: props.onClick }, { children: props.icon }), void 0));
};
export default IconButton;
